const initialState = {
  list: [],
  loadingList: false,
  agent: null,
  messages: [],
  // Agente a que a conversa em `messages` pertence — evita persistir a conversa
  // de um agente sob a chave de outro ao navegar entre eles.
  messagesAgentId: null,
  loadingAgent: false,
  forbidden: false,
  sending: false,
  // Id da bolha que está sendo preenchida pelo streaming; null quando não há
  // stream em curso.
  streamingMessageId: null,
  error: null,
};

// Erro no meio do stream MANTÉM o texto parcial na tela, junto com a barra de
// erro. Se a falha veio antes do primeiro delta não há bolha nenhuma para
// preservar — só o aviso de erro aparece.
function failStream(state, error) {
  return {
    ...state,
    sending: false,
    streamingMessageId: null,
    error,
  };
}

export default function agentsReducer(state = initialState, action) {
  switch (action.type) {
    case "AGENTS_LIST_REQUESTED":
      return { ...state, loadingList: true };
    case "AGENTS_LIST_FETCHED":
      return { ...state, list: action.list, loadingList: false };
    case "AGENT_HISTORY_LOADED":
      return {
        ...state,
        messages: action.messages,
        messagesAgentId: action.agentId,
      };
    case "AGENT_FETCH_REQUESTED":
      return { ...state, loadingAgent: true, forbidden: false, agent: null };
    case "AGENT_FETCHED":
      return { ...state, agent: action.agent, loadingAgent: false };
    case "AGENT_FETCH_FAILED":
      return { ...state, loadingAgent: false, forbidden: action.forbidden };
    case "AGENT_MESSAGE_SENT":
      return {
        ...state,
        messages: [...state.messages, action.message],
        sending: true,
        error: null,
      };
    case "AGENT_REPLY_RECEIVED":
      return {
        ...state,
        messages: [...state.messages, action.message],
        sending: false,
      };
    case "AGENT_FAILED":
      return { ...state, sending: false, error: action.error };
    case "AGENT_STREAM_STARTED":
      // Guarda o id, mas NÃO cria a bolha ainda: o serviço leva alguns segundos
      // até o primeiro token, e uma bolha vazia nesse intervalo tira da tela o
      // único sinal de que algo está acontecendo. A bolha nasce no primeiro
      // delta; até lá quem dá o feedback é o indicador de "digitando".
      return {
        ...state,
        streamingMessageId: action.id,
        sending: true,
        error: null,
      };
    case "AGENT_STREAM_DELTA": {
      const existe = state.messages.some(
        (message) => message.id === action.id
      );

      // O id vem do servidor e não muda durante o stream, então o React não
      // remonta a bolha a cada delta (key={message.id}).
      const messages = existe
        ? state.messages.map((message) =>
            message.id === action.id
              ? { ...message, text: message.text + action.text }
              : message
          )
        : [
            ...state.messages,
            { id: action.id, role: "agent", text: action.text },
          ];

      return { ...state, messages };
    }
    case "AGENT_STREAM_FINISHED":
      return { ...state, sending: false, streamingMessageId: null };
    case "AGENT_STREAM_FAILED":
      return failStream(state, action.error);
    case "AGENT_STREAM_ABORTED":
      // Saiu da tela no meio: descarta a bolha parcial em vez de mostrar erro.
      return {
        ...state,
        messages: state.messages.filter(
          (message) => message.id !== state.streamingMessageId
        ),
        sending: false,
        streamingMessageId: null,
      };
    default:
      return state;
  }
}
